"use strict";

var _interopRequireDefault = require("/Users/vagrant/git/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/Users/vagrant/git/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _apolloClient = require("@/apollo/apolloClient");
var _userQuery = require("@/apollo/queries/user-query");
var state = {
  users: [],
  user: {},
  searchUserName: '',
  searchStaffType: ''
};
var mutations = {
  UPDATE_USERS: function UPDATE_USERS(state, users) {
    state.users = users.map(function (test_user) {
      return test_user;
    });
  },
  UPDATE_USER: function UPDATE_USER(state, user) {
    state.user = user.map(function (test_user) {
      return test_user;
    });
  },
  SET_SEARCH_USER_NAME: function SET_SEARCH_USER_NAME(state, val) {
    state.searchUserName = val;
  },
  SET_SEARCH_STAFF_TYPE: function SET_SEARCH_STAFF_TYPE(state, val) {
    state.searchStaffType = val;
  }
};
var actions = {
  fetchUsers: function () {
    var _fetchUsers = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref) {
      var commit, _sName, _sStaffType, res;
      return regeneratorRuntime.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            commit = _ref.commit;
            if (state.searchUserName) {
              _sName = "".concat(state.searchUserName, "%");
            } else {
              _sName = '%';
            }
            if (state.searchStaffType) {
              _sName = "".concat(state.searchStaffType, "%");
            } else {
              _sStaffType = '%';
            }
            _context.next = 1;
            return _apolloClient.apolloClient.query({
              query: _userQuery.USERS_LIST_QUERY,
              variables: {
                searchName: _sName,
                searchStaffType: _sStaffType
              }
            });
          case 1:
            res = _context.sent;
            commit('UPDATE_USERS', res.data.test_user);
          case 2:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    function fetchUsers(_x) {
      return _fetchUsers.apply(this, arguments);
    }
    return fetchUsers;
  }(),
  fetchDetail: function () {
    var _fetchDetail = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee2(_ref2, id) {
      var commit, res;
      return regeneratorRuntime.wrap(function (_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            commit = _ref2.commit;
            _context2.next = 1;
            return _apolloClient.apolloClient.query({
              query: _userQuery.USER_QUERY,
              variables: {
                id: id
              }
            });
          case 1:
            res = _context2.sent;
            commit('UPDATE_USER', res.data.test_user);
          case 2:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    function fetchDetail(_x2, _x3) {
      return _fetchDetail.apply(this, arguments);
    }
    return fetchDetail;
  }(),
  setSearchUserName: function () {
    var _setSearchUserName = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee3(_ref3, val) {
      var commit;
      return regeneratorRuntime.wrap(function (_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            commit = _ref3.commit;
            commit('SET_SEARCH_USER_NAME', val);
          case 1:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    function setSearchUserName(_x4, _x5) {
      return _setSearchUserName.apply(this, arguments);
    }
    return setSearchUserName;
  }(),
  setSearchStaffType: function () {
    var _setSearchStaffType = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee4(_ref4, val) {
      var commit;
      return regeneratorRuntime.wrap(function (_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            commit = _ref4.commit;
            commit('SET_SEARCH_STAFF_TYPE', val);
          case 1:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }));
    function setSearchStaffType(_x6, _x7) {
      return _setSearchStaffType.apply(this, arguments);
    }
    return setSearchStaffType;
  }()
};
var _default = exports.default = {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions
};